import cn from 'classnames';
import React from 'react';

import styles from './index.module.scss';

interface Props {
  children: React.ReactNode;
  scroll?: boolean;
  scrollAlways?: boolean;
  fill?: boolean;
  fillFlex?: boolean;
  noBorder?: boolean;
  id?: string;
  className?: string;
  noOverflow?: boolean;
  onScroll?: React.UIEventHandler<HTMLDivElement>;
}

function ContentBlock(
  { children, scroll, fill, fillFlex, scrollAlways, noBorder, id, className, noOverflow, onScroll }: Props,
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      id={id}
      className={cn(styles.contentBlock, className, {
        [styles.scroll]: scroll,
        [styles.scrollAlways]: scrollAlways,
        [styles.fill]: fill,
        [styles.noBorder]: noBorder,
        [styles.fillFlex]: fillFlex,
        [styles.noOverflow]: noOverflow,
      })}
      onScroll={onScroll}
    >
      {children}
    </div>
  );
}

export default React.forwardRef(ContentBlock);
